import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  canvas,
  img {
    display: block;
    width: 100%;
  }
`;
